/*
Grommets
 */

const name = 'Grommets'
const id = 'h5fE4GZelfoMdGJInY6L'

export default {
  name,
  id
}
